import { useQuery } from "@tanstack/react-query";
import { getNextPageParam } from "PFCore/helpers/get_next_page_param";
import { useMatchingRequestRefetch } from "PFCore/hooks/use_matching_request_refetch";
import { fetchMatches, MatchesPayload } from "PFCore/services/matches";
import { Match, PaginatedCollection } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";
import { InfiniteQueryOptions, QueryOptions } from "PFTypes/request_options";

import { useInfiniteQuery } from "../use_infinite_query";
import { matchesKeys } from "./query_keys";

export const useMatches = (
  activityId: number | string,
  queryParams: MatchesPayload,
  options: QueryOptions<PaginatedCollection<Match[]>, { status: number }> = {}
) => {
  const queryKey = matchesKeys.activity(activityId, queryParams);
  const getMatchingRefetchInterval = useMatchingRequestRefetch<
    PaginatedCollection<Match[]>,
    { status: number }
  >();

  const query = useQuery({
    queryKey,
    queryFn: () => fetchMatches(activityId, queryParams),
    ...options,
    enabled: options.enabled ?? true,
    refetchInterval: getMatchingRefetchInterval,
    refetchIntervalInBackground: true
  });

  return query;
};

export const useMatchesInfinite = (
  activityId: number | string,
  params: QueryParams,
  options: InfiniteQueryOptions<PaginatedCollection<Match[]>> = {}
) =>
  useInfiniteQuery({
    queryKey: matchesKeys.activity(activityId, { infinite: true, ...params }),
    getNextPageParam,
    queryFn: ({ pageParam }) => fetchMatches(activityId, { ...params, page: pageParam }),
    initialPageParam: 1,
    ...options
  });
